const React = window.React;
const ReactDOM = window.ReactDOM;
import App from './App';

const elGridApp = document.querySelector( '.filterable-grid-for-hub');
if(elGridApp) {
	const root = ReactDOM.client.createRoot(elGridApp);
	root.render(<App />);
}
